var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "theme-autocomplete-custom__field-holder",
      class: {
        "theme-input__field-holder--is-disabled": _vm.disabled,
        "theme-input__field-holder--error":
          !!_vm.errors.has(_vm.newName) && !_vm.model,
        "theme-input__field-holder--focused": _vm.isFocused
      },
      attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label }
    },
    [
      _vm.label
        ? _c("label", { staticClass: "theme-input__label" }, [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "theme-autocomplete-custom" }, [
        _c("div", { staticClass: "theme-autocomplete-custom__input-wrapper" }, [
          _c("input", {
            attrs: { type: "hidden", name: _vm.name },
            domProps: { value: _vm.model }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            staticClass: "theme-input",
            attrs: {
              type: "text",
              name: "_labels[" + _vm.name + "]",
              autocomplete: "off",
              disabled: _vm.disabled
            },
            domProps: { value: _vm.model },
            on: {
              keyup: _vm.suggest,
              keydown: [
                _vm.clearTimeout,
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                }
              ],
              blur: function($event) {
                _vm.blur()
                _vm.isFocused = false
              },
              focus: function($event) {
                _vm.$emit("focus", $event)
                _vm.isFocused = true
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.model = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.errors.has(_vm.newName)
            ? _c("span", {
                staticClass:
                  "icon-warning theme-input__icon theme-input__icon-error"
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showList && _vm.suggestions.length,
                expression: "showList && suggestions.length"
              }
            ],
            staticClass: "theme-autocomplete-custom__list"
          },
          _vm._l(_vm.suggestions, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "theme-autocomplete-custom__item",
                class: {
                  "theme-autocomplete-custom__item--is-selected":
                    item === _vm.selected
                },
                on: {
                  click: function($event) {
                    return _vm.pick(item)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(item) + "\n      ")]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      (!!_vm.errors.has(_vm.newName) && !_vm.model) ||
      !!_vm.errors.has(_vm.newName)
        ? _c("div", { staticClass: "theme-input__error-text" }, [
            _vm._v("\n    " + _vm._s(_vm.errors.first(_vm.newName)) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dec1987", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dec1987","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeAutocompleteCustom.vue
// module id = 616
// module chunks = 1